import { useEffect } from 'react';

import { audioManager } from 'lib/audio/audio-manager';
import { AUDIO_TYPES } from 'lib/audio/audio.types';

import { MintingEnum } from 'modules/Room/game-status/constants/game-status-enum';

import { NULL_ADDRESS } from 'shared/constants/constants';
import { RoomStatusEnum } from 'shared/constants/shared-enums';

interface UseMobileRoomAudioProps {
  isGameFinished: boolean;
  amIWinner: boolean;
  playerBAddress: string;
  mintingLoader: MintingEnum;
  roomStatus: RoomStatusEnum;
  isRoomActive: boolean;
  roundCounter: number;
}

const DELAY_VICTORY_SOUND_MS = 8900;

export function useMobileRoomAudio({
  isGameFinished,
  amIWinner,
  playerBAddress,
  mintingLoader,
  roomStatus,
  isRoomActive,
  roundCounter,
}: UseMobileRoomAudioProps) {
  useEffect(() => {
    if (isGameFinished && playerBAddress !== NULL_ADDRESS) {
      const timer = setTimeout(() => {
        audioManager.playSound(amIWinner ? AUDIO_TYPES.MATCH_WIN : AUDIO_TYPES.MATCH_DEFEAT);
      }, DELAY_VICTORY_SOUND_MS);

      return () => clearTimeout(timer);
    }
  }, [isGameFinished, amIWinner, playerBAddress]);

  useEffect(() => {
    const triggerStates = new Set([
      MintingEnum.YOUR_MOVE,
      MintingEnum.YOUR_REVEAL,
      MintingEnum.TAKE_MONEY_BACK,
    ]);

    if (triggerStates.has(mintingLoader)) {
      audioManager.playSound(AUDIO_TYPES.CONFIRM_MOVE);
    }
  }, [mintingLoader]);

  useEffect(() => {
    if (roomStatus === RoomStatusEnum.Closed) {
      const timer = setTimeout(() => {
        audioManager.playMusic(AUDIO_TYPES.LOBBY_BACKGROUND);
      }, DELAY_VICTORY_SOUND_MS);

      return () => clearTimeout(timer);
    }
  }, [roomStatus]);

  useEffect(() => {
    if (isRoomActive) {
      if (roundCounter === 1) {
        audioManager.playSound(AUDIO_TYPES.GAME_START);
      }
      audioManager.playMusic(AUDIO_TYPES.GAME_BACKGROUND);
    }
  }, [isRoomActive, roundCounter]);
}
